import * as React from 'react'
import Menu from '@mui/material/Menu'
import { useState } from 'react'
import { Drawer, IconButton, Typography } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import { Box } from '@mui/system'
import useStyles from './Styles/useStyles'
import AssignRole from './Users/ModalAssignRole'
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import { ModalDisabledUserAccess } from './Users/ModalDisabledUserAccess'
import { UserSeeMore } from '../../../../components/Modals/Instances/Users/UserSeeMore'
export default function ModalMenuItem ({
  item,
  setLoading,
  userRol,
  userInstance
}) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const [stateSeeMore, setstateSeeMore] = useState(false)
  const [openAssignRole, setOpenAssignRole] = useState(false)
  const [openAccessModal, setopenAccessModal] = useState(false)

  const handleClickButton = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleOpenAssignRole = () => setOpenAssignRole(true)
  const handleCloseAssignRole = () => setOpenAssignRole(false)
  const handleOpenAccessModal = () => setopenAccessModal(true)
  const handleCloseAccessModal = () => setopenAccessModal(false)

  const listSeeMoreUser = (anchor) => (
    <Box className={classes.stepperStyleSeeMore} role="presentation">
      <UserSeeMore
        style={{ marginTop: '5%' }}
        setLoading={setLoading}
        setstateSeeMore={setstateSeeMore}
        item={item}
        userRol={userRol}
        userInstance={userInstance}
      />
    </Box>
  )

  return (
    <>
      <MoreVertIcon
        sx={{
          color: '#026873',
          '&:hover': {
            color: '#00FFAC'
          }
        }}
        onClick={handleClickButton}
      />

      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList
          onClose={handleClose}
          setstateSeeMore={setstateSeeMore}
          handleOpenAssignRole={handleOpenAssignRole}
          handleOpenAccessModal={handleOpenAccessModal}
          userInstance={userInstance}
        />
      </Menu>

      <Drawer anchor={'right'} open={stateSeeMore}>
        {listSeeMoreUser('right')}
      </Drawer>
      <AssignRole
        openAssignRole={openAssignRole}
        handleCloseAssignRole={handleCloseAssignRole}
        user={item}
        userInstance={userInstance}
        userRol={userRol}
        setLoading={setLoading}
      />

      <ModalDisabledUserAccess
        open={openAccessModal}
        handleCloseAccessModal={handleCloseAccessModal}
        userInstance={userInstance}
      />
      {/* <ModalDisabledUserAccess /> */}
    </>
  )
}

function FiltersList ({
  onClose,
  setstateSeeMore,
  handleOpenAssignRole,
  handleOpenAccessModal,
  userInstance
}) {
  const classes = useStyles()

  return (
    <Box
      sx={{
        width: 240
      }}
      className={classes.boxStyle}
      onClick={onClose}
    >
      <IconButton
        onClick={() => {
          onClose()
          setstateSeeMore(true)
        }}
      >
        <Box className={classes.boxTypography}>
          <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
          <Typography className={classes.typographyStyle}>
            Ver detalles
          </Typography>
        </Box>
      </IconButton>
      <IconButton onClick={handleOpenAssignRole}>
        <Box className={classes.boxTypography}>
          <AssignmentIndIcon className={classes.hoverButton} />
          <Typography className={classes.typographyStyle}>
            Asignar un nuevo rol
          </Typography>
        </Box>
      </IconButton>
      {userInstance && userInstance.userAppAccessStatusCode && (
        <IconButton onClick={handleOpenAccessModal}>
          <Box className={classes.boxTypography}>
            <ManageAccountsIcon className={classes.hoverButton} />
            <Typography className={classes.typographyStyle}>
              {userInstance.userAppAccessStatusCode === 'GRANTED'
                ? 'Deshabilitar acceso'
                : 'Habilitar acceso'}
            </Typography>
          </Box>
        </IconButton>
      )}
    </Box>
  )
}
